import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import "../Styles/Pages.css";
import "../Styles/Home.css";
import Footer from "../Components/Footer";
import OurNews from "../Components/OurNews";
import OpenStatus from "../Components/OpenStatus";
import PhotoCarousel from "../Components/PhotoCarousel";
import UnderConstruction from "../Components/UnderConstruction";
import WorkingHours from "../Components/WorkingHours";
import OrnamentalDivider from "../Components/OrnamentalDivider";
import useFirestoreCollection from "../utils/useFirestoreCollection";
import { NavLink } from "react-router-dom";
import CustomCard from "../Components/CustomCard";
import AboutUsImg from "../Images/backgroundUs.jpg";
import WorkingHoursImg from "../Images/mushOven.jpg";

function Home() {
  const { data: adminData } = useFirestoreCollection("administration");
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);

  useEffect(() => {
    if (adminData && adminData.length > 0) {
      setIsUnderMaintenance(adminData[0].isUnderMaintenance);
    }
  }, [adminData]);

  return (
    <div className="page_content">
      <Header />

      <div className="carousel_working_hours_container">
        <OurNews />

        <OpenStatus />

        <header className="home_intro">
          <h1 className="home_intro__brand">The Old House</h1>
          <span className="home_intro__tagline">
            traditional flavours of Rhodes
          </span>
          <span className="home_intro__since">Afantou village - since 1986</span>
        </header>

        <PhotoCarousel />

        <OrnamentalDivider />

        {isUnderMaintenance ? (
          <UnderConstruction />
        ) : (
          <div className="cards">
            <NavLink
              to="/aboutus"
              className="nav-link"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <CustomCard
                title={"About us"}
                content={"Read more"}
                image={AboutUsImg}
                cta
              />
            </NavLink>
            <CustomCard
              title={"Working hours"}
              content={<WorkingHours />}
              image={WorkingHoursImg}
            />
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default Home;
